import r from"../internals/export.js";import o from"../internals/regexp-exec.js";var t=r,e=o;t({target:"RegExp",proto:!0,forced:/./.exec!==e},{exec:e});
